export default {
  getRecalls: (params) => `hrmis/leave-recalls?${getParams(params)}`,
  getRecall: (recallNo) => `hrmis/leave-recalls/${recallNo}/details`,
  saveRecall: "hrmis/leave-recalls/save",
  deleteRecall: "hrmis/leave-recalls/delete",
  submitRecall: "hrmis/leave-recalls/submit",
  sendRecallForApproval: "hrmis/leave-recalls/send-for-approval",
  reopenRecall: "hrmis/leave-recalls/reopen",
  acceptRecall: "hrmis/leave-recalls/accept",
  denyRecall: "hrmis/leave-recalls/deny",
  leaveApplicationOptions: (params) =>
    `hrmis/leave-recalls/leave-application-options?${getParams(params)}`,
};

function getParams(params) {
  return Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&");
}
